<template>
  <div class="bar-charts">
    <div id="barChart" style="width: 80%; height: 300px; transform: translateX(20px)"></div>
  </div>
</template>

<script>
var that = null;
var echarts = require('echarts');
export default {
  name: 'barCharts',
  props: {
    series: {
      type: Array,
      default: function () {
        return [];
      },
    },
    xAxisData: {
      type: Array,
      default: function () {
        return [];
      },
    },
  },
  data() {
    return {};
  },
  watch: {
    xAxisData() {
      let st = setTimeout(() => {
        console.log(that.series, that.xAxisData);
        that.setBarEcharts();
        clearTimeout(st);
      }, 300);
    },
  },
  mounted() {
    that = this;
    console.log('用户数据', that.xAxisData);
    let st = setTimeout(() => {
      that.setBarEcharts();
      clearTimeout(st);
    }, 300);
  },
  methods: {
    //柱形图
    setBarEcharts() {
      let myChart = echarts.init(document.getElementById('barChart'));
      const stackInfo = {};
      for (let i = 0; i < that.series[0].data.length; ++i) {
        for (let j = 0; j < that.series.length; ++j) {
          const stackName = that.series[j].stack;
          if (!stackName) {
            continue;
          }
          if (!stackInfo[stackName]) {
            stackInfo[stackName] = {
              stackStart: [],
              stackEnd: [],
            };
          }
          const info = stackInfo[stackName];
          const data = that.series[j].data[i];
          if (data && data !== '-') {
            if (info.stackStart[i] == null) {
              info.stackStart[i] = j;
            }
            info.stackEnd[i] = j;
          }
        }
      }
      for (let i = 0; i < that.series.length; ++i) {
        const data = that.series[i].data;
        const info = stackInfo[that.series[i].stack];
        for (let j = 0; j < that.series[i].data.length; ++j) {
          // const isStart = info.stackStart[j] === i;
          const isEnd = info.stackEnd[j] === i;
          const topBorder = isEnd ? 20 : 0;
          const bottomBorder = 0;
          data[j] = {
            value: data[j],
            itemStyle: {
              borderRadius: [topBorder, topBorder, bottomBorder, bottomBorder],
            },
          };
        }
      }
      let option = {
        legend: {
          bottom: '10px',
          left: '10px',
        },
        grid: {
          left: 30,
          right: 0,
        },
        color: ['#5470c6', '#91cc75', '#fac858'],
        barWidth: '20px',
        xAxis: {
          type: 'category',
          data: that.xAxisData,
        },
        yAxis: {
          type: 'value',
          name: '使用次数', // 设置Y轴的文案
          nameLocation: 'end', // 设置文案的位置，在Y轴的末端
          nameTextStyle: {
            // 设置文案的样式
            color: '#333',
            fontSize: 10,
            marginLeft: 10,
          },
        },
        series: that.series,
      };
      myChart.setOption(option);
    },
  },
};
</script>

<style lang="scss" scoped></style>
